import { type EntryIdInput, formatEntryId } from "./entryId";
import { type ActionDeps, actingHeaders, apiCall } from "./types";

/**
 * Persist a narrative-only correction.
 *
 * `PATCH /v2/entries/:id` is a merge patch, so sending `description` alone
 * leaves every other field untouched — same partial-body shape `setStatus`
 * uses for `{ status }`. Used by the pre-export restricted-word gate, where
 * there is no edit form in scope to carry a full `EditPayload`.
 *
 * Applies the optimistic cache update itself and rolls it back on failure.
 */
export async function patchDescription(
	deps: ActionDeps,
	id: EntryIdInput,
	description: string,
	timekeeperId?: string | null,
): Promise<void> {
	const entryId = formatEntryId(id);

	const rollback = deps.updateEntries((prev) =>
		prev.map((e) => (e.id === entryId ? { ...e, description } : e)),
	);

	try {
		await apiCall(deps, {
			endpoint: `/v2/entries/${entryId}`,
			method: "PATCH",
			body: { description },
			headers: actingHeaders(timekeeperId),
		});
	} catch (err) {
		rollback();
		throw err;
	}
}
